import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Auth0CallbackComponent } from './auth0-callback/auth0-callback.component';
import { LoginComponent } from './login/login.component';
import { EmailRequiredComponent } from './email-required/email-required.component';
import { AccountNotActivatedComponent } from './account-not-activated/account-not-activated.component';
import { AuthenticationErrorComponent } from './authentication-error/authentication-error.component';
import { AutoLoginComponent } from './auto-login/auto-login.component';
import { AuditorRoleRequiredComponent } from './auditor-role-required/auditor-role-required.component';
import { LayoutComponent } from './layout/layout.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'autologin',
        component: AutoLoginComponent
      },
      {
        path: 'callback',
        component: Auth0CallbackComponent
      },
      {
        path: 'emailrequired',
        component: EmailRequiredComponent
      },
      {
        path: 'accountnotactivated',
        component: AccountNotActivatedComponent
      },
      {
        path: 'authenticationerror',
        component: AuthenticationErrorComponent
      },
      {
        path: 'auditorrolerequired',
        component: AuditorRoleRequiredComponent
      },
      {
        path: 'login',
        component: LoginComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
